import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type { ModelSchema } from '@ember-data/store/types';

import type { RecordAttributes, RecordData } from 'webapp-types';
import { omit } from 'webapp/utils/common';

import ApplicationSerializer from 'webapp/serializers/application';

import type GoalLogRecord from 'webapp/models/goal-log';

export default class GoalLogSerializer extends ApplicationSerializer {
	// json is Raw when it comes from BE, Serialized when BufferedModel.toJSON() runs a record through normalize
	override normalize(
		typeClass: ModelSchema,
		json: RecordData.GoalLog.Raw | RecordData.GoalLog.Serialized,
		prop: string | undefined,
	) {
		// changeValue is not an attribute, so ED ignores it
		const attributes: Partial<RecordAttributes<GoalLogRecord>> & { id?: string | number } = {
			...json,
			change: 'changeValue' in json ? json.changeValue : undefined, // undefined is skipped by ED
		};

		return super.normalize(typeClass, attributes, prop);
	}

	override serialize(snapshot: Snapshot): RecordData.GoalLog.Serialized {
		const attributes = super.serialize(snapshot) as RecordAttributes<GoalLogRecord>;

		// server-owned fields
		return omit(
			attributes,
			'change',
			'changeStr',
			'createdBy',
			'modified',
			'modifiedBy',
			'isPredefinedMessage',
		);
	}
}
